module.exports = __webpack_public_path__ + "static/carbon-button-set-43e840ee20fd30a14c38d8bada4b5bc3.png";